/**
 * Button/index.js
 * desc: button element types and states
 * note: stateless presentational component
 */
'use strict';

import { classNames } from '../../utilities';
import { Link } from 'react-router';
import Loader from '../Loader';
import './styles.css';

const Button = ({ autoFocus, className, 'data-id':dataId, 'data-type':dataType, 'data-name':dataName, disabled, initialLoad, link, loading, name, onClick, children, tabIndex, type, ref, ...rest }) => {

    const handleButtonClick = (e) => {
        e.currentTarget.blur();
        return onClick ? onClick(e) : null;
    };

    const _getClassList = () => classNames(
        'component-button',
        className,
        {
            'loading': loading
        }
    );

    return (
        link
            ?
            <Link
                className={ _getClassList() }
                data-id={ dataId }
                data-type={ dataType }
                data-name={ dataName }
                disabled={ disabled || initialLoad }
                name={ name }
                onClick={ loading ? null : onClick }
                to={ loading ? '#' : link }
                tabIndex={ tabIndex }
                ref={ ref }
                { ...rest }
            >
                { loading ? <Loader/> : children }
            </Link>
            :
            <button
                autoFocus={ autoFocus }
                className={ _getClassList() }
                data-id={ dataId }
                data-type={ dataType }
                data-name={ dataName }
                disabled={ disabled }
                name={ name }
                onClick={ loading ? null : handleButtonClick }
                tabIndex={ tabIndex }
                type={ type }
                ref={ ref }
                { ...rest }
            >
                { loading ? <Loader/> : children }
            </button>
    );

};


export default Button;
